import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center pl-1 pb-1" }
const _hoisted_2 = { class: "text-h4 ml-4" }

import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardHeader',
  setup(__props) {

const router = useRouter()

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      icon: "mdi-arrow-left",
      color: "light",
      density: "comfortable",
      variant: "elevated",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router)?.back()))
    }),
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("h1", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title")
    ])
  ]))
}
}

})